import UserApi from "@/api/user.api";

const errorHandler = error => {
    Vue.prototype.$eventHub.$emit("profile.error", error);
};

export default {
    namespaced: true,
    state: {
        items: [],
        oneItem: {},
        loading: false,
        documents: []
    },
    mutations: {
        setItems: (state, payload) => state.items = payload,
        setDocuments: (state, payload) => state.documents = payload,
        setOneItem: (state, payload) => state.oneItem = payload,
        setLoading: (state, status = true) => (state.loading = status),
    },
    actions: {
        async getItems({state, commit}, id='current'){
            commit("setLoading");
            const { data } = await UserApi.Profile.getPrincipals(id)
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных.')
                })
            commit("setItems", data);
            commit("setLoading", false);
        },
        async getItemOne({state, commit}, id){
            commit("setLoading");
            const data = await UserApi.Profile.setPrincipalData(id)
                .catch(err => {
                    console.log('Произошла ошибка при создании доверителя.')
                })
            commit('setOneItem', data)
            commit("setLoading", false);
        },
        async updateItem({state, commit}, {form, id, userId}){
            commit("setLoading");
            const { data } = await UserApi.Profile.updatePrincipalData(form, id, userId)
                .catch(err => {
                    console.log('Произошла ошибка при создании доверителя.')
                })
            commit("setLoading", false);
        },
        async newItem({state, commit}, form){
            commit("setLoading");
            const { data } = await UserApi.Profile.storePrincipalData(form)
                .catch(err => {
                    console.log('Произошла ошибка при создании доверителя.')
                })
            commit("setLoading", false);
        },
        async deleteItem({state, commit}, id){
            const { data } = await UserApi.Profile.deletePrincipalData(id)
                .catch(err => {
                    console.log('Произошла ошибка при удалении доверителя.')
                })
        },
        async setCurrentItem({state, commit}, {id, isEnabled, userId}){
            await UserApi.Profile.setCurrentPrincipal(id, isEnabled, userId)
                .catch(err => {
                    console.log('Произошла ошибка при выборе доверителя.')
                })
        },
        async getDocuments({state, commit}, id){
            commit("setLoading");
            const { data } = await UserApi.Profile.getPrincipalDocuments(id).catch(errorHandler);
            commit("setDocuments", data);
            commit("setLoading", false);
        },
        async uploadPrincipalDocument({state, commit}, formData, id) {
            commit("setLoading");
            const { data } = await UserApi.Profile.uploadPrincipalDocument(formData, id).catch(errorHandler);
            commit("setDocuments", data);
            commit("setLoading", false);
        },
        async pushType({ commit }, {type, step, principalId}) {
            const { data } = await UserApi.Profile.setPrincipalType(type, step, principalId).catch(errorHandler);
        },
        async pushStatus({ commit }, {status, id}) {
            const { data } = await UserApi.Profile.setPrincipalStatus(status, id).catch(errorHandler);
        },
    },
    getters: {
        DATA_PRINCIPALS: state => state.items,
        DATA_ONE_PRINCIPAL: state => state.oneItem,
        PRINCIPAL_DOCUMENTS: state => state.documents,
        LOADING: state => state.loading,
    }
}
